const BodyReportDetailSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* What is Body Report */}
        <div className="mb-20 md:mb-32">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-dark-gray mb-6">
              BODY REPORTとは
            </h2>
            <p className="text-lg md:text-xl text-dark-gray/80 max-w-4xl mx-auto leading-relaxed">
              身体の中の振動（周波数）の乱れを測定するシステムです。<br />
              細部にわたって臓器の周波数がデータ化され、バランスの状態を分析し、即座に画面に表示します。<br />
              ヘッドフォンを装着して身体の約800箇所を短時間で分析して未病を防ぐ健康法として開発されました。
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-16">
            <div>
              <img
                src="https://media.toriaez.jp/r2315/112.png"
                alt="BODY REPORT システム"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-6">
                振動医学・波動医学に基づく測定
              </h3>
              <p className="text-dark-gray/80 leading-relaxed mb-6">
                ドイツの波動医学・旧ソ連の振動医学を基にして開発された医療器具をベースに開発され、同様の機器はアメリカ、ドイツなど数多くの先進国で医療現場で検査や治療に使われています。
              </p>
              <p className="text-dark-gray/80 leading-relaxed mb-6">
                国内でも、波動医学・波動療法は注目され、数多くの書籍も出版されています。
              </p>
              <div className="bg-light-gold/30 border-l-4 border-gold p-6 rounded-r-xl">
                <p className="text-dark-gray/80 text-sm leading-relaxed">
                  ※ボディリポートの測定・波動セラピーは、病気の診断や治療を目的としたものではありません。測定結果やセラピー内容は現代医学の結果とは異なる場合があります。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* What Can Be Measured */}
        <div className="mb-20 md:mb-32">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-dark-gray mb-6">
              わかること
            </h2>
            <p className="text-lg text-dark-gray/80">
              BODY REPORTで測定できる項目
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-gradient-to-br from-white to-light-gold/20 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gold/10">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <img src="https://media.toriaez.jp/r2315/340.png" alt="健康状態" className="w-12 h-12 object-contain" />
              </div>
              <div className="text-center">
                <div className="inline-block bg-gold text-white text-xs font-bold px-3 py-1 rounded-full mb-3">01</div>
                <h3 className="text-xl font-bold text-dark-gray mb-3">健康状態</h3>
                <p className="text-dark-gray/70 text-sm leading-relaxed">
                  各臓器の周波数を測定し、身体全体の健康バランスを可視化します
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-white to-light-gold/20 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gold/10">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-mental-health-line text-gold text-3xl"></i>
              </div>
              <div className="text-center">
                <div className="inline-block bg-gold text-white text-xs font-bold px-3 py-1 rounded-full mb-3">02</div>
                <h3 className="text-xl font-bold text-dark-gray mb-3">メンタル状態</h3>
                <p className="text-dark-gray/70 text-sm leading-relaxed">
                  精神的なバランスやストレス状態を周波数から分析します
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-white to-light-gold/20 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gold/10">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-shield-cross-line text-gold text-3xl"></i>
              </div>
              <div className="text-center">
                <div className="inline-block bg-gold text-white text-xs font-bold px-3 py-1 rounded-full mb-3">03</div>
                <h3 className="text-xl font-bold text-dark-gray mb-3">病気の予見</h3>
                <p className="text-dark-gray/70 text-sm leading-relaxed">
                  将来なりやすい病気の傾向を把握し、予防・未病対策に活用できます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-white to-light-gold/20 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gold/10">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-restaurant-line text-gold text-3xl"></i>
              </div>
              <div className="text-center">
                <div className="inline-block bg-gold text-white text-xs font-bold px-3 py-1 rounded-full mb-3">04</div>
                <h3 className="text-xl font-bold text-dark-gray mb-3">あなたに合う食べ物</h3>
                <p className="text-dark-gray/70 text-sm leading-relaxed">
                  身体に合う食材や避けるべき食品を周波数から判定します
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-white to-light-gold/20 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gold/10">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-plant-line text-gold text-3xl"></i>
              </div>
              <div className="text-center">
                <div className="inline-block bg-gold text-white text-xs font-bold px-3 py-1 rounded-full mb-3">05</div>
                <h3 className="text-xl font-bold text-dark-gray mb-3">あなたに合う植物・鉱物</h3>
                <p className="text-dark-gray/70 text-sm leading-relaxed">
                  相性の良いハーブや鉱石を測定し、セラピーに活用できます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-white to-light-gold/20 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gold/10">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-virus-line text-gold text-3xl"></i>
              </div>
              <div className="text-center">
                <div className="inline-block bg-gold text-white text-xs font-bold px-3 py-1 rounded-full mb-3">06</div>
                <h3 className="text-xl font-bold text-dark-gray mb-3">アレルゲン</h3>
                <p className="text-dark-gray/70 text-sm leading-relaxed">
                  アレルギー反応を起こす可能性のある物質を特定します
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Flow */}
        <div className="mb-20 md:mb-32">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-dark-gray mb-6">
              診断の流れ
            </h2>
            <p className="text-lg text-dark-gray/80">
              測定は痛みは一切なく、着衣のままリラックスして受けていただけます
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-gold via-gold to-gold/20 -translate-x-1/2"></div>

            <div className="space-y-12 md:space-y-16">
              {/* Step 1 */}
              <div className="relative">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="md:text-right">
                    <div className="inline-block bg-gold text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center mb-4 md:mb-0">01</div>
                  </div>
                  <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gold/10">
                    <div className="flex items-start gap-4">
                      <img src="https://storage.googleapis.com/studio-design-asset-files/projects/BVqXpAlVqR/s-270x270_webp_dc82e21e-1a0d-4431-9da0-049737c92230.webp" alt="カルテ記入" className="w-20 h-20 rounded-xl object-cover" />
                      <div>
                        <h3 className="text-xl font-bold text-dark-gray mb-2">カルテ記入</h3>
                        <p className="text-dark-gray/70 leading-relaxed">ご自身の情報、同意書に記入をしてもらいます。</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="relative">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="md:col-start-2 bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gold/10">
                    <div className="flex items-start gap-4">
                      <img src="https://storage.googleapis.com/studio-design-asset-files/projects/BVqXpAlVqR/s-270x270_webp_5820c917-628a-4dbe-a44c-ca0d1c16056b.webp" alt="説明" className="w-20 h-20 rounded-xl object-cover" />
                      <div>
                        <h3 className="text-xl font-bold text-dark-gray mb-2">説明</h3>
                        <p className="text-dark-gray/70 leading-relaxed">ボディリポートの説明、また周波数で何がわかるか説明をします。</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-start-1 md:row-start-1 md:text-right">
                    <div className="inline-block bg-gold text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center mb-4 md:mb-0">02</div>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="relative">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="md:text-right">
                    <div className="inline-block bg-gold text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center mb-4 md:mb-0">03</div>
                  </div>
                  <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gold/10">
                    <div className="flex items-start gap-4">
                      <img src="https://storage.googleapis.com/studio-design-asset-files/projects/BVqXpAlVqR/s-270x270_webp_cb3b1382-e070-4a69-a148-d7cc71160eac.webp" alt="測定" className="w-20 h-20 rounded-xl object-cover" />
                      <div>
                        <h3 className="text-xl font-bold text-dark-gray mb-2">測定</h3>
                        <p className="text-dark-gray/70 leading-relaxed">ヘッドフォンを装着して測定開始します。その人によって測定時間は変わりますが10〜15分程。</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="relative">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="md:col-start-2 bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gold/10">
                    <div className="flex items-start gap-4">
                      <img src="https://storage.googleapis.com/studio-design-asset-files/projects/BVqXpAlVqR/s-270x270_webp_15409ae7-7c5e-4d23-9b80-d270debd387f.webp" alt="診断結果報告" className="w-20 h-20 rounded-xl object-cover" />
                      <div>
                        <h3 className="text-xl font-bold text-dark-gray mb-2">診断結果報告</h3>
                        <p className="text-dark-gray/70 leading-relaxed">身体、メンタル、チャクラ、食べ物、菌、アレルギーなどの診断結果をお伝えします。ご希望の方は周波数セラピー、レメディーの作成、薬やサプリの相性テストもいたします。</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-start-1 md:row-start-1 md:text-right">
                    <div className="inline-block bg-gold text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center mb-4 md:mb-0">04</div>
                  </div>
                </div>
              </div>

              {/* Step 5 */}
              <div className="relative">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="md:text-right">
                    <div className="inline-block bg-gold text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center mb-4 md:mb-0">05</div>
                  </div>
                  <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gold/10">
                    <div className="flex items-start gap-4">
                      <img src="https://storage.googleapis.com/studio-design-asset-files/projects/BVqXpAlVqR/s-270x270_webp_91e1abbb-4ab6-4323-b952-2e6501c9f5b9.webp" alt="アドバイス" className="w-20 h-20 rounded-xl object-cover" />
                      <div>
                        <h3 className="text-xl font-bold text-dark-gray mb-2">アドバイス</h3>
                        <p className="text-dark-gray/70 leading-relaxed">食生活、運動、メンタル、生活改善に向けたアドバイスをします。</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 6 */}
              <div className="relative">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="md:col-start-2 bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gold/10">
                    <div className="flex items-start gap-4">
                      <img src="https://storage.googleapis.com/studio-design-asset-files/projects/BVqXpAlVqR/s-270x270_webp_e944a23e-4bbf-4380-a753-5c0656cc3846.webp" alt="診断用紙のお渡し" className="w-20 h-20 rounded-xl object-cover" />
                      <div>
                        <h3 className="text-xl font-bold text-dark-gray mb-2">診断用紙のお渡し</h3>
                        <p className="text-dark-gray/70 leading-relaxed">ご自身で記入していただいたものをお渡し致します。</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-start-1 md:row-start-1 md:text-right">
                    <div className="inline-block bg-gold text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center mb-4 md:mb-0">06</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div className="bg-gradient-to-br from-light-gold/30 to-white rounded-3xl p-8 md:p-12">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-8 text-center">
            BODY REPORTの特徴
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                <i className="ri-heart-pulse-line text-gold text-3xl"></i>
              </div>
              <h4 className="text-lg font-bold text-dark-gray mb-2">痛みなし</h4>
              <p className="text-dark-gray/70 text-sm">ヘッドフォンを装着するだけで測定完了</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                <i className="ri-time-line text-gold text-3xl"></i>
              </div>
              <h4 className="text-lg font-bold text-dark-gray mb-2">短時間</h4>
              <p className="text-dark-gray/70 text-sm">わずか10〜15分で約800箇所を分析</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                <i className="ri-shield-check-line text-gold text-3xl"></i>
              </div>
              <h4 className="text-lg font-bold text-dark-gray mb-2">未病対策</h4>
              <p className="text-dark-gray/70 text-sm">病気になる前に身体の変化を察知</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BodyReportDetailSection;
